module.exports = __webpack_public_path__ + "img/dsmenu.fda2d68f.jpg";